/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRoleDirective } from './user-role.directive';


@NgModule({
  declarations: [UserRoleDirective],
  imports: [
    CommonModule,
   
  ],
  exports: [
    UserRoleDirective
  ]
})
export class UserRoleModule { }
